import './ActionPanel.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import Loader from '../DAcApplication/components/loader';
var ActionPanel = function ActionPanel(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "action-panel__module-group"
  }, /*#__PURE__*/React.createElement("button", {
    className: "".concat(props.inactive ? 'disabled' : '', " action-panel__btn btn btn-primary"),
    onClick: props.onSubmit
    // disabled={props.isLoading || props.inactive}
  }, /*#__PURE__*/React.createElement("span", {
    className: "action-panel__btn-title ".concat(props.isLoading ? 'action-panel__btn-title--loading' : '')
  }, props.submitText), props.isLoading && /*#__PURE__*/React.createElement(Loader, null))));
};
export default ActionPanel;
var commonStyles = "cym1yo8";
var rtlStyles = "r101o0h";
var ltrStyles = "l1fq2e9j";